@switch (status()) {
  @case ('pending') {
    @if (current().url) {
      @if (safeUrl(); as src) {
        <section class="payment payment--frame" aria-label="Secure payment">
          <header class="payment__header">
            <span class="payment__title">Complete payment to confirm</span>
            @if (remaining()) {
              <span
                class="payment__timer"
                [class.payment__timer--warn]="remaining() === 'Expired'"
                role="timer"
                aria-live="off"
              >
                @if (remaining() === 'Expired') {
                  Expired
                } @else {
                  {{ remaining() }} left
                }
              </span>
            }
          </header>

          <iframe
            class="payment__iframe"
            [src]="src"
            title="Secure payment"
            sandbox="allow-scripts allow-forms allow-same-origin allow-popups allow-top-navigation"
            referrerpolicy="no-referrer"
          ></iframe>
        </section>
      } @else {
        <section class="payment payment--redirect">
          <p class="payment__intro">
            Complete your secure payment to confirm this booking.
          </p>
          @let amountDue = current().amount;
          @if (amountDue != null) {
            <p class="payment__amount">
              {{ amountDue | currency: (current().currency || 'USD') : 'symbol' : '1.2-2' }} due
            </p>
          }
          <button
            type="button"
            class="payment__cta"
            [disabled]="!interactive()"
            (click)="openRedirect()"
          >
            Complete Payment
          </button>
        </section>
      }
    } @else {
      <section class="payment payment--placeholder" role="status" aria-live="polite">
        <img src="assets/images/send-loader.svg" alt="" width="28" height="28" />
        <span>Securing your slot — payment link incoming…</span>
      </section>
    }
  }

  @case ('expired') {
    <section class="payment payment--terminal payment--expired" role="status">
      <p>Payment link expired — your hold was released.</p>
      @if (interactive()) {
        <button type="button" class="payment__cta" (click)="onRetry()">Retry payment</button>
      }
    </section>
  }

  @case ('cancelled') {
    <section class="payment payment--terminal payment--cancelled" role="status">
      <p>Payment cancelled — your hold was released.</p>
      @if (interactive()) {
        <button type="button" class="payment__cta" (click)="onRetry()">Retry payment</button>
      }
    </section>
  }

  @default {
    <!-- paid / refunded / not_applicable: parent renders the normal confirmation UI -->
  }
}
